export default __webpack_public_path__ + "static/media/3-6-2.89eb07d7.jpg";